import { render, staticRenderFns } from "./Monsters.vue?vue&type=template&id=d99b9be6&scoped=true&"
import script from "./Monsters.vue?vue&type=script&lang=ts&"
export * from "./Monsters.vue?vue&type=script&lang=ts&"
import style0 from "./Monsters.vue?vue&type=style&index=0&id=d99b9be6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d99b9be6",
  null
  
)

export default component.exports